export default __webpack_public_path__ + "static/media/worldwide.314da83b.png";